
import {
    ButtonGroup,
    Dropdown,
    Nav,
    Tab,
} from "react-bootstrap";
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    MissionStore,
    reSetSatDetails,
    setMission,
    setSatelliteClone,
    setSatelliteEdit,
    setSatellites,
} from '../../store/MissionSlice';
import { navigateTo, truncateNumber } from '../CommonComponents/CommonFunctions';
import { toast } from 'react-toastify';
import MissionService from '../../service/MissionService';
import Loader from "../../Layouts/Loader/Loader";
import CreateSatModel from "./Satellites/CreateSatModel";
import Dialog from "../CommonComponents/Dialog";
import TrueTwinConfig from "./TrueTwins/TrueTwinConfig";
import OperateModal from "./Operate/modal/OperateModal";
import CustomToolTip from "../CommonComponents/CustomToolTip";
import CommandCenterService from "../../service/CommandCenterService";
import GroundstationsAndProviders from "./GroundStationsAndProviders/GroundstationsAndProviders";
import Features from "./Feature/FeaturesList";
import useFeature from "./Feature/useFeature";

const MissionDetails = () => {
    const params = useParams();
    const { mission_name, mission_id, tab_name } = params
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = React.useState(true);
    const userData = useSelector((state: { mission: MissionStore }) => state.mission.userData);
    const Satellites: any = useSelector((state: { mission: MissionStore }) => state.mission.Satellites);
    const Mission = useSelector((state: { mission: MissionStore }) => state.mission.Mission);
    const projects = useSelector((state: { mission: MissionStore }) => state.mission.projects);

    const satelliteEdit = useSelector((state: { mission: MissionStore }) => state.mission.satelliteEdit);
    const satelliteClone = useSelector((state: { mission: MissionStore }) => state.mission.satelliteClone);

    const [showBtnGroup, setShowBtnGroup] = React.useState('');

    const [satelliteData, setSatelliteData] = React.useState({})
    const [satellite_name, setSatellite_name] = React.useState(mission_name);
    const [satellite_des, setSatellite_des] = React.useState('');
    const [openSatModel, setOpenSatModal] = React.useState<any>(false);
    const [openDeleteModel, setOpenDeleteModal] = React.useState(false);
    const [promoteSatellite, setPromoteSatellite] = React.useState(false);
    const [openCreateTrueTwin, setOpenCreateTrueTwin] = React.useState({
        isCreateTrueTwin: false,
        sat_id: ''
    });
    const [isGetTT, setIsGetTT] = React.useState(false)

    const [openGSForm, setOpenGSForm] = React.useState(false);
    const [gsList, setGsList] = useState([]);
    const { getFeatureManager } = useFeature();

    useEffect(() => { dispatch(reSetSatDetails()) }, [])

    const [stepIndex, setStepIndex] = React.useState(0)
    const [hasTruetwin, setHasTruetwin] = useState(false)
    const [isMissionIdSet, setIsMissionIdSet] = useState(false)
    const [missionModelData, setMissionModelData] = React.useState([])

    const MissionSteps = [
        {
            title: 'Configaration',
            mission_index: 0,
        },
        {
            title: 'Development',
            mission_index: 1,
        }, {
            title: 'Simulate',
            mission_index: 2,
        }, {
            title: 'Launched',
            mission_index: 3,
        }
    ]



    const navigateTo_Sat_details = (sat) => {
        navigateTo(`${mission_name}/${mission_id}/sat_details/${sat?.['name']}/${sat?.['uniqueId']}/Payloads`, navigate);
    }

    const navigate_to_mission = () => {
        navigateTo(``, navigate)
    }

    const mission_internal_step = (tab_name) => {
        navigateTo(
            `${mission_name}/_details/${mission_id}/${tab_name}`,
            navigate
        );
    }


    const navigate_to_new_mission_modeling = () => {
        if (missionModelData.length === 0) {
            MissionService.createMissionModellingModal(mission_id).then((res) => {
                navigateTo(`${mission_name}/${mission_id}/new_mission_modeling/${res.data.scenario_id}`, navigate)
            }).catch((err) => {
                console.log(err)
            })
        } else {
            navigateTo(`${mission_name}/${mission_id}/new_mission_modeling/${missionModelData?.[0]?.['scenario_id']}`, navigate)
        }
    }

    const edit_mission = () => {
        navigateTo(`${projects[0]?.['name']}/edit_mission/${Mission?.['name']}/${Mission?.['uniqueId']}`, navigate)
    }

    const promote_ucp = () => {
        MissionService.post_ucp_data(mission_id, missionModelData?.[0]?.['scenario_id'])?.then((res) => {
            if (res) {
                toast.success("UCP Post Success")
            }
        }).catch((error) => {
            toast.error("Something went wrong")
        })
    }

    const navigate_to_view_satellite = (sat) => {
        navigateTo(`${mission_name}/${mission_id}/view_satellite/${sat?.['name']}/${sat?.['uniqueId']}/view`, navigate)
    }

    const navigate_to_operate = () => {
        navigateTo(`${mission_name}/${mission_id}/operate-dashboard`, navigate)
    }

    const get_satellites = () => {
        MissionService.get_satellites_by_mission_id(mission_id)?.then((res) => {
            if (res) {
                dispatch(setSatellites(res?.data))
                setIsGetTT(true)
            }
            setLoading(false)
        }).catch((err) => {
            console.error(err);
            setLoading(false)
        })
    }

    const get_mision_modelling_data = (mission_id) => {
        setLoading(true)
        MissionService.getMissionModellingModels(mission_id)?.then((res) => {
            if (res) {
                setMissionModelData(res.data)
                setLoading(false)
            }
        }).catch((err) => {
            console.log(err)
            setLoading(false)
        })
    }

    useEffect(() => {
        if (mission_id) {
            get_mission()
            get_satellites()
            get_mision_modelling_data(mission_id)
        }
    }, [mission_id])


    const deletesatellite = (satelliteData) => {
        setLoading(true)
        MissionService.delete_satellite(satelliteData?.['uniqueId'])?.then((res) => {
            if (res) {
                toast.success('Satellite deleted successfully', { toastId: 'o' })
                get_satellites()
            } else {
                setLoading(false)
            }
        }).catch((err) => {
            console.error(err);
            toast.error("Something went wrong while deleting satellite. Please try again. ", { toastId: 'o' });
            setLoading(false)
        })
    }

    const create_new_satellite = async () => {
        if (satellite_name !== '') {
            let sat = {
                name: satellite_name,
                description: satellite_des,
                draftMode: 'Yes',
                "containing-mission": mission_id,
                versions: [
                    {
                        assembly: {
                            Payloads: [],
                            Edge: [],
                            Template: '',
                        },
                    },
                ],
                "swap-info": {
                    totalBusSize: 0,
                    totalMass: 0,
                    totalPower: 0,
                    totalBusSizePercent: 0,
                    totalMassPercent: 0,
                    totalPowerPercent: 0,
                    totalPayloadSize: 0,
                    totalPayloadMass: 0,
                    totalPayloadPower: 0,
                },
            };
            MissionService.create_new_satellites(sat)
                ?.then((res) => {
                    if (res.data) {
                        navigateTo(`${mission_name}/${mission_id}/${satellite_name}/${res?.data?.['uniqueId']}/add_new_payload`, navigate)
                    }
                })
                .catch((err) => {
                    if (err.response?.data === "Satellite with same name already exists") {
                        toast.error('The name you entered is already in use for another satellite.', { toastId: 'o' });
                    } else {
                        toast.error("Something went wrong while creating satellite. Please try again. ", { toastId: 'o' });
                        setOpenSatModal(false)
                    }
                });
        } else {
            toast.error('Please enter satellite name', { toastId: 'o' })
        }
    }

    const reset_selected_sat_data = () => {
        if (satelliteEdit) {
            dispatch(setSatelliteEdit(false))
        } else if (satelliteClone) {
            dispatch(setSatelliteClone(false))
        }
        setSatellite_name('')
        setSatellite_des('')
        setSatelliteData({})
    }

    const clone_existing_satellite = () => {
        setLoading(true)
        MissionService.clone_satellite(satelliteData?.['uniqueId'], satellite_name)?.then((res) => {
            if (res.data) {
                toast.success('Satellite cloned successfully', { toastId: 'o' })
                get_satellites()
                reset_selected_sat_data()
                setOpenSatModal(false)
            }
        }).catch((err) => {
            if (err.response?.data === "Satellite with same name already exists") {
                toast.error('The name you entered is already in use for another satellite.', { toastId: 'o' });
            } else {
                toast.error("Something went wrong while creating satellite. Please try again. ", { toastId: 'o' });
                reset_selected_sat_data()
            }
            setLoading(false)
        })
    }


    const edit_satellite = () => {
        let sat = {
            ...satelliteData,
            'name': satellite_name,
            'description': satellite_des
        }
        MissionService.update_satellites(satelliteData?.['uniqueId'], sat)
            ?.then((res) => {
                if (res.data) {
                    if (hasTruetwin) {
                        setOpenSatModal(false)
                        setHasTruetwin(false)
                        toast.warning("Cannot edit satellite configuration if it has TrueTwin's")
                        get_satellites()
                    } else {
                        if (!satelliteData?.['versions']?.[0]?.['assembly']?.['Payloads']) {
                            return navigateTo(`${mission_name}/${mission_id}/${satellite_name}/${satelliteData?.['uniqueId']}/add_new_payload`, navigate)
                        } else if (satelliteData?.['versions']?.[0]?.['assembly']?.['Payloads']?.length > 4) {
                            return navigateTo(`${mission_name}/${mission_id}/${satellite_name}/${satelliteData?.['uniqueId']}/preview_payload`, navigate)
                        } else if (satelliteData?.['draftMode'] === 'No') {
                            return navigateTo(`${mission_name}/${mission_id}/${satellite_name}/${satelliteData?.['uniqueId']}/review_satellite`, navigate)
                        } else {
                            return navigateTo(`${mission_name}/${mission_id}/${satellite_name}/${satelliteData?.['uniqueId']}/add_new_template`, navigate)
                        }
                    }
                }
                reset_selected_sat_data()
            })
            .catch((err) => {
                if (err.response?.data === "Satellite with same name already exists") {
                    toast.error('The name you entered is already in use for another satellite.', { toastId: 'o' });
                } else {
                    toast.error("Something went wrong while creating satellite. Please try again. ", { toastId: 'o' });
                    setOpenSatModal(false)
                    reset_selected_sat_data()
                }
            });
    }


    const get_mission = () => {
        MissionService.get_mission_by_id(mission_id)?.then((res) => {
            if (res.data) {
                dispatch(setMission(res.data))
                setLoading(false);
            }
        }).catch((err) => {
            console.error(err);
        })
    }


    const delete_mission = () => {
        if (Mission?.['satelliteIds']?.length > 0) {
            toast.error("Mission Can't be Deleted. Please delete all satellites first to delete the mission.", { toastId: 'o' });
        } else {
            setLoading(true);
            const resp = MissionService.deleteMission(mission_id);
            resp?.then(result => {
                if (result) {
                    setLoading(false);
                    toast.success(
                        "Mission deleted successfully"
                        , { toastId: 'o' });
                    navigate_to_mission();
                }
            }).catch(err => {
                toast.error(
                    "Mission Can't be Deleted"
                    , { toastId: 'o' });
                setLoading(false);
            })
        }

    }

    const add_gs_to_mission = (gsList: any) => {
        setLoading(true);
        let data = {
            "name": Mission?.['name'],
            "description": Mission?.['description'],
            "mission-attributes": Mission?.['mission-attributes'],
            'gsConfig': Mission?.['gsConfig'] ? Mission?.['gsConfig'] : [],
            'gsList': gsList,
        }

        MissionService.updateMission(mission_id, data)?.then((res) => {
            if (res) {
                if (openGSForm) {
                    setOpenGSForm(false)
                }
                if (gsList.length < Mission?.['gsList']?.length) {
                    toast.success('Ground Station deleted successfully', { toastId: 'p' })
                } else {
                    if (gsList.length > 0) {
                        toast.success('Ground Station added successfully', { toastId: 'o' })
                    }
                }
                get_mission()
            }
        }).catch((err) => {
            console.error(err);
        })
    }

    const delete_gs_from_mission = (gsId) => {
        let filter_gs_list = Mission?.['gsList']?.filter((gs) => gs !== gsId);
        add_gs_to_mission(filter_gs_list);
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsMissionIdSet(true)
        }, 1000);
        return () => clearTimeout(timer);

    }, [])

    useEffect(() => {
        if (Mission?.['name'] !== '') {
            setStepIndex(1)
        }
        if (Satellites?.length > 0) {
            setStepIndex(2)
        }
        if (Satellites?.TrueTwins?.length > 0) {
            setStepIndex(3)
        }
    }, [Mission, Satellites])


    return (
        <div className='h-100 w-100' onClick={() => {
            setShowBtnGroup('')
        }}>
            {loading && <Loader />}
            <div className='pt-7 px-5'>
                <div className="d-flex gap-3">
                    <div id="back_icon_button" onClick={navigate_to_mission}
                        className="back-icon-button"
                    >
                        <img src={require('../../assets/images/Mission.svg').default} width='20px' height='20px' alt='mission' />
                    </div>
                    <div className="sat-info-box-compact">
                        <div className='border-curve-gradient '>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className='d-flex flex-column w-90'>
                                    <div id="satellite_name" className="sat-name">
                                        {mission_name}
                                    </div>
                                    <div className="sat-sub-info">
                                        <img
                                            id="mission_icon"
                                            src={require("../../assets/images/icons/rocket-sm.svg").default}
                                            className="me-2"
                                            alt="Angle"
                                        />
                                        <span id="mission_iclinationAngle">
                                            {truncateNumber(Number(Mission?.['mission-attributes']?.['inclination_angle']), 2)}
                                            <sup>o</sup>
                                        </span>
                                        <span id="mission_altitudeRange" className="text-lowercase">
                                            {`${truncateNumber(Number(Mission?.['mission-attributes']?.['Altitude_range']?.['min']), 2)} - ${truncateNumber(Number(Mission?.['mission-attributes']?.['Altitude_range']?.['max']), 2)}`}{" "}
                                            km
                                        </span>
                                    </div>
                                </div>
                                <div className="sat-progress d-flex flex-column align-items-center">
                                    {/* <div className="sat-progress-title mb-2">Mission Progress</div> */}
                                    {/* <ol className="c-stepper mb-0">
                                        {MissionSteps.map((data, i) => {
                                            return (
                                                <li
                                                    key={i}
                                                    className={
                                                        stepIndex === data.mission_index
                                                            ? "c-stepper__item active"
                                                            : stepIndex > data.mission_index
                                                                ? "c-stepper__item ready"
                                                                : "c-stepper__item"
                                                    }
                                                >
                                                    <span className="c-stepper__title"><span className="tt-show ms-4">{data.title}</span></span>
                                                </li>
                                            );
                                        })}
                                    </ol> */}
                                </div>
                                <ButtonGroup size="sm" className="flex-nowrap">
                                    {userData?.["user_roles"]?.[0] !== "project_viewer" && (
                                        <div className="btn-list more-button" >
                                            <Dropdown drop="end" id="mission_dropdown" >
                                                <Dropdown.Toggle size="sm" variant="transparent">
                                                    <i className="fe fe-more-vertical fs-20"></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        id="edit_mission"
                                                        eventKey="0"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            edit_mission();
                                                        }}
                                                    >
                                                        Edit
                                                    </Dropdown.Item>
                                                    {userData?.['feature-allowed']?.['collect'] === 'Yes' &&
                                                        <Dropdown.Item
                                                            disabled={!missionModelData?.[0]?.['overview']?.['noOfConstellations']}
                                                            eventKey="1"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                // delete_mission();
                                                                promote_ucp()
                                                            }}
                                                        >
                                                            Promote to collect
                                                        </Dropdown.Item>}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    )}
                                </ButtonGroup>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="w-tabs pt-5">
                    <div className="panel panel-tabs">
                        <Tab.Container id="left-tabs-example" defaultActiveKey={tab_name}>
                            <Nav
                                variant="pills"
                                className="panel-tabs nav-tabs w-auto"
                                style={{ borderBottom: "none" }}
                            >
                                <Nav.Item onClick={() => { mission_internal_step('Configuration') }}>
                                    <Nav.Link eventKey="Configuration">
                                        <svg id="mission_configuration_icon" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.83495 12.072L7.83343 12.0727C7.61611 12.1756 7.36445 12.1318 7.18868 11.956L4.53567 9.30303C4.36673 9.13409 4.31696 8.87383 4.41898 8.65836C4.87505 7.69645 5.90417 5.66824 7.20526 4.36715C10.9526 0.619811 13.9713 0.611928 15.218 0.821917C15.3303 0.842396 15.4337 0.896593 15.5144 0.977305L15.6908 0.800922L15.5144 0.977306C15.5951 1.05803 15.6493 1.16143 15.6698 1.27372C15.8798 2.52052 15.8718 5.53916 12.1246 9.28645C10.8233 10.5877 8.79434 11.6254 7.83495 12.072ZM5.32364 12.9252L5.32362 12.9252L5.32419 12.9281C5.39651 13.2892 5.37853 13.6627 5.27185 14.0152C5.16518 14.3677 4.97312 14.6885 4.71272 14.949C4.58348 15.0782 4.37058 15.2127 4.08502 15.346C3.80312 15.4775 3.4669 15.6004 3.10525 15.713C2.38232 15.938 1.57615 16.1163 0.937744 16.2398C0.539066 16.3145 0.185438 15.9609 0.260171 15.5622C0.383848 14.9233 0.560032 14.1172 0.783996 13.3944C0.896031 13.0329 1.01859 12.6969 1.1504 12.4152C1.28391 12.13 1.41918 11.9175 1.5499 11.7884L1.55101 11.7873C1.8115 11.5269 2.13226 11.3348 2.4848 11.2281C2.83735 11.1215 3.21078 11.1035 3.57194 11.1758L3.57483 11.1764C4.44358 11.3397 5.16028 12.0564 5.32364 12.9252ZM5.31066 3.86939C3.96527 5.50182 2.99847 7.55896 2.6863 8.26463L1.04205 7.55891C0.666522 7.39714 0.572452 6.90438 0.862914 6.61391L3.3584 4.11843C3.68914 3.78769 4.16818 3.63952 4.63303 3.73078C4.63333 3.73084 4.63362 3.7309 4.63392 3.73095L5.31066 3.86939ZM8.23538 13.8137C8.94104 13.5015 10.9982 12.5347 12.6306 11.1893L12.769 11.8661C12.7691 11.8664 12.7692 11.8666 12.7692 11.8669C12.8605 12.3318 12.7123 12.8109 12.3816 13.1416L9.88609 15.6371C9.59564 15.9275 9.1029 15.8335 8.94111 15.458C8.9411 15.458 8.9411 15.458 8.94109 15.4579L8.23538 13.8137ZM10.5935 3.99841C9.54342 3.99841 8.68533 4.85649 8.68533 5.90654C8.68533 6.95658 9.54342 7.81467 10.5935 7.81467C11.6435 7.81467 12.5016 6.95658 12.5016 5.90654C12.5016 4.85649 11.6435 3.99841 10.5935 3.99841Z" fill="#D2D2D2" strokeWidth='0.5' />
                                        </svg>
                                        <span id="mission_configuration_label">
                                            Mission Configuration
                                        </span>
                                    </Nav.Link>
                                </Nav.Item>


                                {userData?.['feature-allowed']?.['missionModelling'] === 'Yes' &&
                                    <Nav.Item onClick={() => {
                                        mission_internal_step('Modelling')
                                        get_mision_modelling_data(mission_id)
                                    }}>
                                        <Nav.Link eventKey="Modelling">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                <g clip-path="url(#clip0_1373_14692)">
                                                    <circle cx="1.50977" cy="2.24805" r="1" stroke="#F0F0F0" stroke-width="0.5" />
                                                    <circle cx="1.50977" cy="14.7207" r="1" stroke="#F0F0F0" stroke-width="0.5" />
                                                    <circle cx="14.4375" cy="14.7441" r="1" stroke="#F0F0F0" stroke-width="0.5" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.75976 2.2517L2.75977 2.24805C2.75977 2.07529 2.72472 1.91072 2.66135 1.76106C2.75235 1.74599 2.845 1.73828 2.93844 1.73828H4.40918C4.54725 1.73828 4.65918 1.85021 4.65918 1.98828C4.65918 2.12635 4.54725 2.23828 4.40918 2.23828H2.93844C2.87826 2.23828 2.81855 2.24282 2.75976 2.2517ZM1.74219 3.47648C1.66688 3.49064 1.58919 3.49805 1.50977 3.49805C1.41792 3.49805 1.32839 3.48814 1.24219 3.46934V13.4994C1.32839 13.4806 1.41792 13.4707 1.50977 13.4707C1.58919 13.4707 1.66688 13.4781 1.74219 13.4923V3.47648ZM2.93844 15.2545C2.84166 15.2545 2.74573 15.2463 2.6516 15.2301C2.71851 15.0804 2.75682 14.915 2.7596 14.7411C2.81844 14.75 2.8782 14.7545 2.93844 14.7545H13.0622C13.1049 14.7545 13.1474 14.7522 13.1895 14.7477C13.1902 14.9222 13.2267 15.0882 13.292 15.2389C13.2163 15.2493 13.1395 15.2545 13.0622 15.2545H2.93844ZM14.7584 13.5333V11.9971C14.7584 11.859 14.6465 11.7471 14.5084 11.7471C14.3704 11.7471 14.2584 11.859 14.2584 11.9971V13.5052C14.3175 13.4966 14.378 13.4922 14.4395 13.4922C14.5497 13.4922 14.6566 13.5065 14.7584 13.5333Z" fill="#F0F0F0" />
                                                    <path d="M13.1478 6.85611C13.9314 6.85745 14.6919 6.59074 15.3029 6.1003C15.3718 6.04562 15.4282 5.97689 15.4684 5.89869C15.5087 5.82049 15.5317 5.73462 15.5361 5.64682C15.5413 5.55377 15.5265 5.4607 15.4928 5.37381C15.4591 5.28692 15.4073 5.20821 15.3407 5.14294L13.5889 3.39198C13.8346 3.14635 14.093 2.88811 14.3388 2.63618C14.3892 2.59209 14.4333 2.548 14.4837 2.49761C14.5399 2.43792 14.5711 2.35909 14.5711 2.27717C14.5711 2.19525 14.5399 2.11641 14.4837 2.05672C14.4544 2.02721 14.4196 2.00378 14.3812 1.98779C14.3428 1.9718 14.3016 1.96357 14.26 1.96357C14.2184 1.96357 14.1772 1.9718 14.1388 1.98779C14.1004 2.00378 14.0656 2.02721 14.0363 2.05672C13.7338 2.35275 13.4439 2.64877 13.1415 2.9448L11.3896 1.19384C11.3234 1.12851 11.2445 1.07746 11.1578 1.04387C11.0711 1.01029 10.9784 0.994873 10.8855 0.998589C10.7978 1.00368 10.7121 1.02704 10.634 1.06717C10.5558 1.1073 10.4869 1.16332 10.4317 1.23163C9.90835 1.88508 9.64169 2.70706 9.68184 3.54315L8.7681 4.46271L7.29981 2.99519C7.2423 2.93541 7.17331 2.88785 7.09697 2.85536C7.02063 2.82287 6.93851 2.80613 6.85554 2.80613C6.77257 2.80613 6.69045 2.82287 6.61411 2.85536C6.53777 2.88785 6.46878 2.93541 6.41127 2.99519L4.47036 4.9351C4.35299 5.0531 4.28711 5.21274 4.28711 5.37913C4.28711 5.54553 4.35299 5.70516 4.47036 5.82317L5.9418 7.2907L5.68343 7.54264C5.37173 7.85545 5.19673 8.27895 5.19673 8.72044C5.19673 9.16193 5.37173 9.58543 5.68343 9.89824L6.63498 10.8493C6.7892 11.0049 6.97274 11.1285 7.17501 11.2128C7.37727 11.2971 7.59425 11.3405 7.8134 11.3405C8.03254 11.3405 8.24952 11.2971 8.45178 11.2128C8.65405 11.1285 8.83759 11.0049 8.99181 10.8493L9.24388 10.5974L10.7122 12.0649C10.8302 12.1822 10.99 12.248 11.1564 12.248C11.3229 12.248 11.4826 12.1822 11.6007 12.0649L13.5416 10.1187C13.659 10.0007 13.7249 9.84104 13.7249 9.67465C13.7249 9.50825 13.659 9.34862 13.5416 9.23061L12.0796 7.76938L12.9934 6.84981C13.0447 6.85493 13.0962 6.85703 13.1478 6.85611ZM4.91147 5.38228L6.85869 3.43607L8.32068 4.9036L6.38292 6.84351L4.91147 5.38228ZM13.0974 9.6778L11.1564 11.6177L9.68815 10.1502L11.6291 8.21027L13.0974 9.6778ZM9.80158 4.31785C9.96097 4.89517 10.2679 5.42112 10.6921 5.84404C11.1164 6.26697 11.6434 6.57234 12.2214 6.73014L8.54124 10.4084C8.34725 10.602 8.08434 10.7107 7.81025 10.7107C7.53615 10.7107 7.27325 10.602 7.07925 10.4084L6.1214 9.45106C5.92776 9.25716 5.819 8.9944 5.819 8.72044C5.819 8.44648 5.92776 8.18372 6.1214 7.98982L9.80158 4.31785ZM11.1375 5.39488C10.6421 4.90614 10.3478 4.24958 10.3128 3.55469C10.2778 2.8598 10.5046 2.17703 10.9485 1.64103L12.9209 3.61243L14.8996 5.59013L14.9122 5.60903C14.3668 6.04355 13.6803 6.26193 12.984 6.22242C12.2876 6.18292 11.6302 5.8883 11.1375 5.39488Z" fill="#F0F0F0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1373_14692">
                                                        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span id="mission_modelling_label">
                                                Mission Models
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                }
                                <Nav.Item onClick={() => { mission_internal_step('Satellites') }}>
                                    <Nav.Link eventKey="Satellites">
                                        <svg id="satellites_icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.6018 8.33147C13.7163 8.33337 14.798 7.95405 15.667 7.25654C15.7649 7.17877 15.8452 7.08102 15.9023 6.9698C15.9595 6.85859 15.9923 6.73647 15.9986 6.61158C16.0059 6.47925 15.9849 6.34688 15.937 6.2233C15.8891 6.09972 15.8154 5.98779 15.7207 5.89496L13.2292 3.40471C13.5787 3.05536 13.9462 2.68809 14.2957 2.32978C14.3674 2.26708 14.4301 2.20437 14.5018 2.13271C14.5817 2.04782 14.6261 1.9357 14.6261 1.81919C14.6261 1.70268 14.5817 1.59056 14.5018 1.50567C14.4602 1.46369 14.4106 1.43037 14.356 1.40763C14.3014 1.38489 14.2428 1.37319 14.1837 1.37319C14.1245 1.37319 14.066 1.38489 14.0113 1.40763C13.9567 1.43037 13.9072 1.46369 13.8655 1.50567C13.4353 1.92669 13.0231 2.3477 12.5929 2.76871L10.1013 0.278461C10.0072 0.185543 9.89502 0.112946 9.77168 0.065177C9.64834 0.0174078 9.5165 -0.00451428 9.38433 0.000771388C9.25959 0.00800876 9.13775 0.0412326 9.02663 0.0983103C8.9155 0.155388 8.81754 0.235059 8.73903 0.332208C7.99466 1.26156 7.6154 2.43059 7.67251 3.6197L6.37297 4.92753L4.28473 2.84037C4.20294 2.75535 4.10482 2.68771 3.99625 2.64151C3.88768 2.59531 3.77089 2.57149 3.65288 2.57149C3.53488 2.57149 3.41809 2.59531 3.30951 2.64151C3.20094 2.68771 3.10282 2.75535 3.02103 2.84037L0.26062 5.59936C0.0936943 5.76719 0 5.99423 0 6.23088C0 6.46753 0.0936943 6.69456 0.26062 6.8624L2.35334 8.94955L1.98588 9.30786C1.54257 9.75275 1.29368 10.3551 1.29368 10.983C1.29368 11.6108 1.54257 12.2132 1.98588 12.6581L3.3392 14.0107C3.55853 14.232 3.81957 14.4077 4.10723 14.5276C4.3949 14.6475 4.70349 14.7092 5.01516 14.7092C5.32684 14.7092 5.63543 14.6475 5.92309 14.5276C6.21076 14.4077 6.4718 14.232 6.69113 14.0107L7.04963 13.6524L9.13786 15.7395C9.30578 15.9064 9.53294 16 9.76971 16C10.0065 16 10.2336 15.9064 10.4016 15.7395L13.162 12.9716C13.3289 12.8037 13.4226 12.5767 13.4226 12.3401C13.4226 12.1034 13.3289 11.8764 13.162 11.7085L11.0827 9.63034L12.3822 8.32251C12.4552 8.32979 12.5285 8.33278 12.6018 8.33147ZM0.887987 6.23536L3.65736 3.46742L5.73664 5.55457L2.9807 8.31355L0.887987 6.23536ZM12.5301 12.3445L9.76971 15.1035L7.68147 13.0164L10.4419 10.2574L12.5301 12.3445ZM7.8428 4.7215C8.06949 5.54257 8.50596 6.29059 9.10934 6.89209C9.71273 7.49358 10.4623 7.92788 11.2844 8.15231L6.05032 13.3836C5.77442 13.6589 5.40051 13.8135 5.01068 13.8135C4.62085 13.8135 4.24695 13.6589 3.97105 13.3836L2.60876 12.0221C2.33337 11.7463 2.17869 11.3726 2.17869 10.983C2.17869 10.5933 2.33337 10.2196 2.60876 9.94386L7.8428 4.7215ZM9.74282 6.25327C9.03817 5.55817 8.61969 4.6244 8.56992 3.63611C8.52015 2.64782 8.8427 1.67677 9.47395 0.914461L12.2792 3.71823L15.0934 6.53096L15.1113 6.55784C14.3356 7.17582 13.3592 7.48641 12.3689 7.43023C11.3785 7.37404 10.4436 6.95502 9.74282 6.25327Z" fill="#D2D2D2" strokeWidth='0.5' />
                                        </svg>
                                        <span id="satellites_label">
                                            Satellites
                                        </span>
                                    </Nav.Link>
                                </Nav.Item>

                                <Nav.Item onClick={() => { mission_internal_step('Features'); getFeatureManager(mission_id) }}>
                                    <Nav.Link eventKey="Features">
                                        <svg id="Geo-Feature_icon" width="13" height="17" viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.12646 8.354C9.22035 8.26011 9.27309 8.13278 9.27309 8C9.27309 7.86722 9.22035 7.73989 9.12646 7.646C9.03257 7.55211 8.90524 7.49937 8.77246 7.49937C8.63969 7.49937 8.51235 7.55211 8.41846 7.646L5.27246 10.793L4.12646 9.646C4.07997 9.59951 4.02478 9.56264 3.96404 9.53748C3.90331 9.51232 3.8382 9.49937 3.77246 9.49937C3.70672 9.49937 3.64162 9.51232 3.58088 9.53748C3.52014 9.56264 3.46495 9.59951 3.41846 9.646C3.37197 9.69249 3.3351 9.74768 3.30994 9.80842C3.28478 9.86916 3.27183 9.93426 3.27183 10C3.27183 10.0657 3.28478 10.1308 3.30994 10.1916C3.3351 10.2523 3.37197 10.3075 3.41846 10.354L4.91846 11.854C4.96491 11.9006 5.02008 11.9375 5.08083 11.9627C5.14157 11.9879 5.20669 12.0009 5.27246 12.0009C5.33823 12.0009 5.40335 11.9879 5.46409 11.9627C5.52484 11.9375 5.58002 11.9006 5.62646 11.854L9.12646 8.354ZM4.77246 0.5C4.46213 0.499838 4.1594 0.595928 3.90597 0.775028C3.65254 0.954129 3.4609 1.20742 3.35746 1.5H1.77246C1.37464 1.5 0.993105 1.65804 0.711801 1.93934C0.430496 2.22064 0.272461 2.60218 0.272461 3V15C0.272461 15.3978 0.430496 15.7794 0.711801 16.0607C0.993105 16.342 1.37464 16.5 1.77246 16.5H10.7725C11.1703 16.5 11.5518 16.342 11.8331 16.0607C12.1144 15.7794 12.2725 15.3978 12.2725 15V3C12.2725 2.60218 12.1144 2.22064 11.8331 1.93934C11.5518 1.65804 11.1703 1.5 10.7725 1.5H9.18746C9.08402 1.20742 8.89238 0.954129 8.63895 0.775028C8.38552 0.595928 8.08279 0.499838 7.77246 0.5H4.77246ZM4.27246 2C4.27246 1.86739 4.32514 1.74022 4.41891 1.64645C4.51268 1.55268 4.63985 1.5 4.77246 1.5H7.77246C7.90507 1.5 8.03225 1.55268 8.12601 1.64645C8.21978 1.74022 8.27246 1.86739 8.27246 2C8.27246 2.13261 8.21978 2.25979 8.12601 2.35355C8.03225 2.44732 7.90507 2.5 7.77246 2.5H4.77246C4.63985 2.5 4.51268 2.44732 4.41891 2.35355C4.32514 2.25979 4.27246 2.13261 4.27246 2ZM1.77246 2.5H3.35746C3.4609 2.79258 3.65254 3.04587 3.90597 3.22497C4.1594 3.40407 4.46213 3.50016 4.77246 3.5H7.77246C8.08279 3.50016 8.38552 3.40407 8.63895 3.22497C8.89238 3.04587 9.08402 2.79258 9.18746 2.5H10.7725C10.9051 2.5 11.0322 2.55268 11.126 2.64645C11.2198 2.74022 11.2725 2.86739 11.2725 3V15C11.2725 15.1326 11.2198 15.2598 11.126 15.3536C11.0322 15.4473 10.9051 15.5 10.7725 15.5H1.77246C1.63985 15.5 1.51268 15.4473 1.41891 15.3536C1.32514 15.2598 1.27246 15.1326 1.27246 15V3C1.27246 2.86739 1.32514 2.74022 1.41891 2.64645C1.51268 2.55268 1.63985 2.5 1.77246 2.5Z" fill="#D8D8D8" />
                                        </svg>
                                        <span id="Geo-Feature_label">
                                            GeoFeatures
                                        </span>
                                    </Nav.Link>
                                </Nav.Item>

                                <Nav.Item onClick={() => { mission_internal_step('Ground_Stations') }}>
                                    <Nav.Link eventKey="Ground_Stations">
                                        <svg id="Ground_Stations_icon" width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.1309 1.42135C11.2365 1.6837 11.237 1.97666 11.1324 2.2394C11.0277 2.50213 10.8258 2.71445 10.5687 2.83228L10.6905 6.82093L11.7763 7.65426C11.8862 7.73816 11.9605 7.86031 11.9846 7.99646C12.0086 8.13262 11.9806 8.27285 11.9061 8.38932C11.8316 8.50579 11.716 8.59001 11.5824 8.62526C11.4487 8.66052 11.3066 8.64423 11.1843 8.57964C10.4381 9.38596 9.51327 9.94923 8.46168 10.0953C7.78101 10.1906 7.07665 10.1069 6.36732 9.83184L5.92641 10.4249L8.53443 12.6212C8.78135 12.829 8.96212 13.0985 9.06243 13.3978H9.10101C9.43721 13.3978 9.70893 13.6436 9.70341 13.9489C9.70341 14.2542 9.4317 14.5001 9.09495 14.5001H0.941838C0.605639 14.5001 0.333923 14.2542 0.333923 13.9489C0.333923 13.6623 0.573121 13.4281 0.88507 13.4005V10.4023C0.884952 10.0961 0.956387 9.79423 1.09368 9.52061C1.23096 9.24699 1.4303 9.00924 1.67579 8.82635C1.92128 8.64345 2.20612 8.52046 2.50758 8.4672C2.80904 8.41393 3.11878 8.43186 3.41208 8.51956L3.84528 7.94857C3.36909 7.33294 3.09076 6.66826 3.00037 5.97547C2.86093 4.90624 3.17839 3.8486 3.77308 2.89787C3.67163 2.80046 3.61127 2.66796 3.60433 2.52749C3.5974 2.38703 3.64443 2.24922 3.73578 2.1423C3.82714 2.03538 3.95592 1.96742 4.09574 1.95235C4.23557 1.93728 4.37587 1.97623 4.48791 2.06123L5.47722 2.82016L9.01283 1.96698C8.9795 1.701 9.04425 1.43199 9.19494 1.2103C9.34563 0.988605 9.57194 0.829419 9.83152 0.762531C10.0911 0.695642 10.3662 0.725637 10.6052 0.8469C10.8443 0.968163 11.0315 1.17238 11.1309 1.42135ZM6.03939 3.25115L7.85928 4.64831L9.37769 2.65867C9.3187 2.60646 9.26548 2.54807 9.21896 2.48451L6.03884 3.2517L6.03939 3.25115ZM8.29634 4.98396L10.1261 6.38773L10.0203 2.93204C9.97252 2.9282 9.92501 2.9212 9.87813 2.91109L8.29634 4.98341V4.98396ZM4.6505 3.57523C4.1947 4.33856 3.99905 5.10962 4.09384 5.83272C4.1947 6.60653 4.63838 7.409 5.62603 8.15305C6.61424 8.8982 7.52198 9.1137 8.30901 9.00402C9.0244 8.90481 9.70452 8.52673 10.2998 7.91054L4.6505 3.57523ZM7.74574 13.3978L3.40491 9.74256C3.27932 9.63669 3.1261 9.56892 2.96328 9.54721C2.80047 9.5255 2.63484 9.55076 2.4859 9.62002C2.33696 9.68928 2.2109 9.79965 2.12258 9.93814C2.03426 10.0766 1.98735 10.2375 1.98736 10.4017V13.3978H7.74574Z" fill="#D8D8D8" strokeWidth='0.5' />
                                        </svg>
                                        <span id="Ground_Stations_label">
                                            Ground Stations
                                        </span>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content style={{ width: '100%', borderTop: '0.5px solid rgba(52, 52, 52, 1)' }}>
                                <Tab.Pane eventKey="Configuration">
                                    <div className="d-flex gap-10 w-100 mt-3">
                                        <div className='d-flex flex-column justify-content-start'>
                                            {/* <div className='d-flex flex-column w-40'>
                                                <h4 className="color-atmos fs-30 text-capitalize">{mission_name} </h4>
                                                {Mission?.['description'] && Mission?.['description'] !== '' && <h6 className="w-100">{Mission?.['description']}</h6>}
                                            </div> */}
                                            <div className='d-flex flex-column gap-2 w-700px'>
                                                <div className='d-flex w-100 gap-3'>
                                                    <div className="stats-alpha border border-radius-8 w-30">
                                                        <strong id="mission_inclination_angle_value">{truncateNumber(Number(Mission?.['mission-attributes']?.['inclination_angle']), 2)}
                                                            <sup>o</sup>
                                                        </strong>
                                                        <span id="mission_inclination_angle_label">Inclination Angle</span>
                                                    </div>
                                                    <div className="stats-alpha border border-radius-8 w-30">
                                                        <strong id="sun_syncronous_orbit_value">{Mission?.['mission-attributes']?.['sunSynchronous']}</strong>
                                                        <span id="sun_syncronous_orbit_label">Sun Synchronous Orbit</span>
                                                    </div>
                                                    <div className="stats-alpha border border-radius-8 w-30">
                                                        <strong id="mission_altitude_range_value">
                                                            {`${truncateNumber(Number(Mission?.['mission-attributes']?.['Altitude_range']?.['min']), 2)} - ${truncateNumber(Mission?.['mission-attributes']?.['Altitude_range']?.['max'], 2)} km`}
                                                        </strong>
                                                        <span id="mission_altitude_range_label">Altitude Range</span>
                                                    </div>
                                                </div>
                                                <div className='d-flex w-100 gap-3'>
                                                    <div className="stats-alpha border border-radius-8 w-30">
                                                        <strong id="mission_duration_value">{Mission?.['mission-attributes']?.['mission_duration']}</strong>
                                                        <span id="mission_duration_label">Duration</span>
                                                    </div>
                                                    <div className="stats-alpha border border-radius-8 w-30">
                                                        <strong id="mission_mass_class_value">{Mission?.['mission-attributes']?.['mass_class']}</strong>
                                                        <span id="mission_mass_class_label">Mass Class</span>
                                                    </div>
                                                    {/* <div className="stats-alpha border border-radius-8 w-30">
                                                        <strong>{Mission?.['mission-attributes']?.['propulsion']}</strong>
                                                        <span>Propulsion</span>
                                                    </div> */}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="Modelling">
                                    <div className="mission-card-view gap-3 mt-5">
                                        {missionModelData.length === 0 && <div className="add-mission-card" onClick={navigate_to_new_mission_modeling}>
                                            <div className="d-flex flex-column mt-2 align-items-center gap-2">
                                                <svg width="34" height="35" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.83495 12.072L7.83343 12.0727C7.61611 12.1756 7.36445 12.1318 7.18868 11.956L4.53567 9.30303C4.36673 9.13409 4.31696 8.87383 4.41898 8.65836C4.87505 7.69645 5.90417 5.66824 7.20526 4.36715C10.9526 0.619811 13.9713 0.611928 15.218 0.821917C15.3303 0.842396 15.4337 0.896593 15.5144 0.977305L15.6908 0.800922L15.5144 0.977306C15.5951 1.05803 15.6493 1.16143 15.6698 1.27372C15.8798 2.52052 15.8718 5.53916 12.1246 9.28645C10.8233 10.5877 8.79434 11.6254 7.83495 12.072ZM5.32364 12.9252L5.32362 12.9252L5.32419 12.9281C5.39651 13.2892 5.37853 13.6627 5.27185 14.0152C5.16518 14.3677 4.97312 14.6885 4.71272 14.949C4.58348 15.0782 4.37058 15.2127 4.08502 15.346C3.80312 15.4775 3.4669 15.6004 3.10525 15.713C2.38232 15.938 1.57615 16.1163 0.937744 16.2398C0.539066 16.3145 0.185438 15.9609 0.260171 15.5622C0.383848 14.9233 0.560032 14.1172 0.783996 13.3944C0.896031 13.0329 1.01859 12.6969 1.1504 12.4152C1.28391 12.13 1.41918 11.9175 1.5499 11.7884L1.55101 11.7873C1.8115 11.5269 2.13226 11.3348 2.4848 11.2281C2.83735 11.1215 3.21078 11.1035 3.57194 11.1758L3.57483 11.1764C4.44358 11.3397 5.16028 12.0564 5.32364 12.9252ZM5.31066 3.86939C3.96527 5.50182 2.99847 7.55896 2.6863 8.26463L1.04205 7.55891C0.666522 7.39714 0.572452 6.90438 0.862914 6.61391L3.3584 4.11843C3.68914 3.78769 4.16818 3.63952 4.63303 3.73078C4.63333 3.73084 4.63362 3.7309 4.63392 3.73095L5.31066 3.86939ZM8.23538 13.8137C8.94104 13.5015 10.9982 12.5347 12.6306 11.1893L12.769 11.8661C12.7691 11.8664 12.7692 11.8666 12.7692 11.8669C12.8605 12.3318 12.7123 12.8109 12.3816 13.1416L9.88609 15.6371C9.59564 15.9275 9.1029 15.8335 8.94111 15.458C8.9411 15.458 8.9411 15.458 8.94109 15.4579L8.23538 13.8137ZM10.5935 3.99841C9.54342 3.99841 8.68533 4.85649 8.68533 5.90654C8.68533 6.95658 9.54342 7.81467 10.5935 7.81467C11.6435 7.81467 12.5016 6.95658 12.5016 5.90654C12.5016 4.85649 11.6435 3.99841 10.5935 3.99841Z" stroke="white" stroke-width="0.5"></path></svg>
                                                <strong>Start Mission Modeling</strong>
                                            </div>
                                        </div>}

                                        {missionModelData.length > 0 && <div className="mission-card min-h-auto border bg-light-black d-flex gap-3 flex-column" onClick={navigate_to_new_mission_modeling}>
                                            <div className="d-flex align-items-center justify-content-between">
                                                {/* <span className="fs-20 color-atmos">{missionModelData[0]?.['name']}</span> */}
                                                <span className="fs-20 color-atmos">Active Model</span>
                                                {/* <span className="fs-18 "> {missionModelData[0]?.['createdAt']}</span> */}
                                            </div>
                                            <div className="d-flex gap-3 flex-column">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div className="d-flex flex-column w-50">
                                                        <span>{missionModelData[0]?.['overview']?.['noOfSatellites']}</span>
                                                        <span className="fs-13 opacity-75">{parseFloat(missionModelData[0]?.['overview']?.['noOfSatellites']) > 1 ? "Satellites" : "Satellite"}</span>
                                                    </div>
                                                    <div className="d-flex flex-column w-50" style={{ alignContent: "start" }}>
                                                        <span>{missionModelData[0]?.['overview']?.['noOfConstellations']}</span>
                                                        <span className="fs-13 opacity-75">{parseFloat(missionModelData[0]?.['overview']?.['noOfConstellations']) > 1 ? "Constellations" : "Constellation"}</span>
                                                    </div>
                                                </div>

                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div className="d-flex flex-column w-50">
                                                        <span>{missionModelData[0]?.['overview']?.['noOfGroundStations']}</span>
                                                        <span className="fs-13 opacity-75">{parseFloat(missionModelData[0]?.['overview']?.['noOfGroundStations']) > 1 ? "Ground Stations" : "Ground Station"}</span>
                                                    </div>
                                                    <div className="d-flex flex-column w-50" style={{ alignContent: "start" }}>
                                                        <span>{missionModelData[0]?.['overview']?.['noOfGeoFeatures']}</span>
                                                        <span className="fs-13 opacity-75">{parseFloat(missionModelData[0]?.['overview']?.['noOfGeoFeatures']) > 1 ? "GeoFeatures" : "GeoFeature"}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                    </div>

                                </Tab.Pane>
                                <Tab.Pane eventKey="Satellites">
                                    <div className="mission-card-view gap-3 mt-3">
                                        {Satellites?.length > 0 && Satellites?.map((satellite, i) => {
                                            return (
                                                <div key={i} >
                                                    <div id={satellite?.['name']} title={satellite?.['name']} className="mission-card h-200 gap-2 d-flex flex-column justify-content-between" key={i} onClick={(e) => {
                                                        e.preventDefault();
                                                        if (satellite?.['draftMode'] && satellite?.['draftMode'] === 'Yes') {
                                                            toast.warning('Satellite configuration is incomplete. Edit to Configure.', { toastId: 'o' })
                                                        } else {
                                                            navigateTo_Sat_details(satellite)
                                                        }
                                                    }}>
                                                        <div className="d-flex justify-content-between w-100">
                                                            <div className='d-flex flex-column w-90'>
                                                                <div className="d-flex align-items-center gap-2 w-100">
                                                                    <img id={'satellite_icon'} src={require('../../assets/images/sat.svg').default} width='20px' height='20px' alt={`Satellite`} />
                                                                    <div id={'satellite_name'} className={`d-flex ${satellite?.['name'].length > 15 ? 'flex-column' : 'gap-2 align-items-center'} w-100`}>
                                                                        <span className={`text-truncate fs-20 color-atmos ${satellite?.['name'].length > 15 ? 'w-90' : 'w-auto'}`}>{satellite?.['name']}</span>
                                                                        {(satellite?.['draftMode'] && satellite?.['draftMode'] === 'Yes') && <span className='color-atmos fs-14 font-italic'>(Configuration pending)</span>}
                                                                    </div>
                                                                </div>
                                                                <span className='text-gray text-truncate'>{satellite?.['summery']}</span>
                                                            </div>
                                                            <span className="text-center align-middle" onClick={(e) => {
                                                                e.stopPropagation()
                                                                setShowBtnGroup('')
                                                            }}>
                                                                <ButtonGroup size="sm" className="flex-nowrap">
                                                                    {userData['resource_access']?.['ATMOS-RESOURCE-SERVER']?.['roles'][0] !== 'project_viewer' &&
                                                                        <div className="btn-list more-button">
                                                                            <Dropdown id="sat_edit_delete_btn" drop="end" show={showBtnGroup === satellite?.['uniqueId']}>
                                                                                <Dropdown.Toggle size="sm" variant="transparent" onClick={(e) => {
                                                                                    e.stopPropagation()
                                                                                    if (showBtnGroup === satellite?.['uniqueId']) {
                                                                                        setShowBtnGroup('')
                                                                                    } else {
                                                                                        setShowBtnGroup(satellite?.['uniqueId'])
                                                                                    }
                                                                                }}>
                                                                                    <i className="fe fe-more-vertical fs-20"></i>
                                                                                </Dropdown.Toggle>
                                                                                <Dropdown.Menu>
                                                                                    {satellite?.['draftMode'] && satellite?.['draftMode'] === 'No' && <Dropdown.Item eventKey="0" id="view_sat"
                                                                                        onClick={(e) => {
                                                                                            navigate_to_view_satellite(satellite)
                                                                                        }}>
                                                                                        View
                                                                                    </Dropdown.Item>}
                                                                                    <Dropdown.Item eventKey="1" id="edit_sat"
                                                                                        onClick={(e) => {
                                                                                            if (satellite?.['trueTwinIds'] && satellite?.['trueTwinIds']?.length > 0) {
                                                                                                setHasTruetwin(true)
                                                                                            } else {
                                                                                                setHasTruetwin(false)
                                                                                            }
                                                                                            dispatch(setSatelliteEdit(true))
                                                                                            setSatellite_name(satellite?.['name']);
                                                                                            setSatellite_des(satellite?.['description']);
                                                                                            setSatelliteData(satellite);
                                                                                            setOpenSatModal(true);
                                                                                        }}>
                                                                                        Edit
                                                                                    </Dropdown.Item>
                                                                                    <Dropdown.Item eventKey="2" id="clone_sat"
                                                                                        onClick={() => {
                                                                                            let sat_name = satellite?.['name']?.includes('copy') ? satellite?.['name']?.includes('copy-') ? satellite?.['name']?.split('(')[0] + '(copy-' + `${+satellite?.['name']?.split('-')[1][0] + 1}` + ')' : satellite?.['name']?.split('(')[0] + '(copy-1)' : satellite?.['name'] + ' (copy)'
                                                                                            dispatch(setSatelliteClone(true))
                                                                                            setSatellite_name(sat_name);
                                                                                            setSatellite_des(satellite?.['description'])
                                                                                            setSatelliteData(satellite);
                                                                                            setOpenSatModal(true)
                                                                                        }}>
                                                                                        Clone
                                                                                    </Dropdown.Item>
                                                                                    {(userData?.['feature-allowed']?.['operate'] === 'Yes' && !satellite?.['promoted']) &&
                                                                                        <Dropdown.Item eventKey="3" id="promote_sat"
                                                                                            onClick={() => {
                                                                                                setPromoteSatellite(satellite);
                                                                                            }}>
                                                                                            Promote
                                                                                        </Dropdown.Item>
                                                                                    }
                                                                                    <Dropdown.Item eventKey="4" id="delete_sat"
                                                                                        onClick={(e) => {
                                                                                            setSatelliteData(satellite);
                                                                                            setOpenDeleteModal(true);
                                                                                        }}>
                                                                                        Delete
                                                                                    </Dropdown.Item>
                                                                                    <Dropdown.Item eventKey="5" id="create_trueTwin_sat"
                                                                                        onClick={(e) => {
                                                                                            if (satellite?.['draftMode'] && satellite?.['draftMode'] === 'Yes') {
                                                                                                toast.warning('Satellite configuration is incomplete. Configure it before create TrueTwin.', { toastId: 'o' })
                                                                                            } else {
                                                                                                if (userData?.['feature-allowed']?.['ttMaxLimit'] === (satellite?.['trueTwinIds'] && satellite?.['trueTwinIds']?.length)) {
                                                                                                    toast.warning('You have reached the maximum number of TrueTwins', { toastId: 'o' })
                                                                                                } else {
                                                                                                    setOpenCreateTrueTwin({
                                                                                                        isCreateTrueTwin: true,
                                                                                                        sat_id: satellite?.['uniqueId']
                                                                                                    })

                                                                                                }
                                                                                            }
                                                                                        }}>
                                                                                        Create TrueTwin
                                                                                    </Dropdown.Item>
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>
                                                                        </div>
                                                                    }
                                                                </ButtonGroup>
                                                            </span>
                                                        </div>

                                                        <div className={`d-flex gap-2 align-items-center me-3 mt-2`}>
                                                            <span id={'payload_label'} style={{ opacity: 0.8, fontSize: '16px', height: '36px', alignItems: 'center', display: 'flex', justifyContent: 'center' }} >Payload</span>
                                                            {satellite?.['versions']?.[0]?.['assembly']?.['Payloads']?.length > 0 &&
                                                                satellite?.['versions']?.[0]?.['assembly']?.['Payloads']?.map((item, id) => {
                                                                    let payloadType = item?.['atmos-data']?.['component_specific_attributes']?.['payloadType']
                                                                    if (id < 4) {
                                                                        return (
                                                                            <CustomToolTip
                                                                                title={item?.['user_data']?.['payload_name']}
                                                                                key={id}
                                                                                placement="top"
                                                                            >
                                                                                <div id="payload_type" className='payload-hover-ani' onClick={(e) => {
                                                                                    e.stopPropagation()
                                                                                    if (satellite?.['draftMode'] && satellite?.['draftMode'] === 'Yes') {
                                                                                        toast.warning('Satellite configuration is incomplete. Edit to Configure .', { toastId: 'o' })
                                                                                    } else {
                                                                                        navigateTo(`${mission_name}/${mission_id}/${satellite['name']}/${satellite['uniqueId']}/payload_details/${item?.['user_data']?.['payload_name']}/${item?.['user_data']?.['id']}/${'Payloads'}`, navigate)
                                                                                    }
                                                                                }}>
                                                                                    {payloadType === 'Earth Observation' && <img src={require('../../assets/images/EarthObserve.svg').default} width='28px' height='28px' alt={payloadType} />}
                                                                                    {payloadType === 'Communication' && <img src={require('../../assets/images/Communication.svg').default} width='28px' height='28px' alt={payloadType} />}
                                                                                    {payloadType === 'Other' && <img src={require('../../assets/images/Other.svg').default} width='28px' height='28px' alt={payloadType} />}
                                                                                </div>
                                                                            </CustomToolTip>
                                                                        )
                                                                    }
                                                                })}
                                                            {satellite?.['versions']?.[0]?.['assembly']?.['Payloads']?.length > 4 && <div className='payload-hover-ani'>
                                                                <i className="fe fe-plus fs-12"></i>{satellite?.['versions']?.[0]?.['assembly']?.['Payloads']?.length - 4}
                                                            </div>}
                                                        </div>
                                                        <div className={`mission-card-footer w-100 pt-2 mt-3`}>
                                                            <TrueTwinIcon setOpenCreateTrueTwin={setOpenCreateTrueTwin} satellite={satellite} getTT={isGetTT} setIsGetTT={setIsGetTT} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        {userData['resource_access']?.['ATMOS-RESOURCE-SERVER']?.['roles'][0] !== 'project_viewer' &&
                                            <div className="add-mission-card" onClick={() => {
                                                setSatellite_name('')
                                                setOpenSatModal(true)
                                            }}>
                                                <div className="d-flex flex-column mt-2 align-items-center gap-2">
                                                    <i className="fe fe-plus fs-40 mb-1 align-self-center"></i>
                                                    <strong>Create Satellite</strong>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="Ground_Stations">
                                    <GroundstationsAndProviders />
                                </Tab.Pane>
                                <Tab.Pane eventKey="Features">
                                    <div className="mt-1">
                                        <Features />
                                    </div>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </div>
                </div>
            </div>

            {openSatModel &&
                <CreateSatModel
                    close={() => {
                        reset_selected_sat_data()
                        setOpenSatModal(false)
                    }}
                    satellite_name={satellite_name} setSatellite_name={setSatellite_name} satellite_des={satellite_des}
                    setSatellite_des={setSatellite_des} onclick={satelliteEdit ? edit_satellite : satelliteClone ? clone_existing_satellite : create_new_satellite}
                    type={satelliteEdit ? 'Update' : satelliteClone ? 'Clone' : 'Create'} />
            }

            <Dialog
                onClick={(event) => {
                    if (event) {
                        deletesatellite(satelliteData);
                    }
                    setOpenDeleteModal(false)
                }}
                openModel={openDeleteModel} comment={`${satelliteData?.['trueTwinIds']?.length > 0 ? 'The satellite has TrueTwins associated with it. Are you sure you want to delete this satellite along with all its TrueTwins and their data?' : 'Are you sure you want to delete this satellite?'}`}
            />

            {openCreateTrueTwin.isCreateTrueTwin && <TrueTwinConfig mission_name={mission_name} mission_id={mission_id} sat_id={openCreateTrueTwin.sat_id} close={() => {
                setOpenCreateTrueTwin({ isCreateTrueTwin: false, sat_id: '' })
                setIsGetTT(true)
            }} />}

            {promoteSatellite && <OperateModal
                close={() => {
                    setPromoteSatellite(false)
                    navigate_to_operate()
                }}
                navigate_to_operate={navigate_to_operate}
                hasSelectedSatellite={promoteSatellite}
                openModal={{ type: 'promote' }}
            />}

        </div>
    )
}



const TrueTwinIcon = ({ setOpenCreateTrueTwin, satellite, getTT, setIsGetTT }) => {
    const params = useParams();
    const navigate = useNavigate();
    const { mission_name, mission_id } = params
    const [TrueTwinData, setTrueTwinData] = useState([])

    useEffect(() => {
        if (getTT && satellite['uniqueId']) {
            CommandCenterService.get_TrueTwins_by_satId(satellite['uniqueId'])?.then((tt) => {
                if (tt?.data) {
                    const filter_tt = tt.data.filter(tt => tt.Category !== "RealSat")
                    setTrueTwinData(filter_tt)
                }
            }).catch((e) => {
                console.log(e);
            })
            setIsGetTT(false)
        }
    }, [getTT, satellite['uniqueId']])

    return (

        <div className='d-flex gap-2 align-items-center'>
            {TrueTwinData?.length === 0 && <span className='fs-13 d-flex gap-2 align-items-center' onClick={(e) => {
                e.stopPropagation()
                if (satellite?.['draftMode'] && satellite?.['draftMode'] === 'Yes') {
                    toast.warning('Satellite configuration is incomplete. Configure it before create TrueTwin.', { toastId: 'o' })
                } else {
                    setOpenCreateTrueTwin({
                        isCreateTrueTwin: true,
                        sat_id: satellite?.['uniqueId']
                    })
                }
            }}>
                <span id="create_true_twin" className='fs-14 d-flex color-atmos'>Create TrueTwin</span>
                <CustomToolTip
                    title={'Create TrueTwin'}
                    placement="top"
                >
                    <span id="create_trueTwin_icon" className='add-mission-TrueTwin'>
                        <i className="fe fe-plus fs-16 color-atmos"></i>
                    </span>
                </CustomToolTip>
            </span>}
            {TrueTwinData?.length > 0 && <span id="true_twin" className='fs-14 color-atmos'>TrueTwin</span>}

            {TrueTwinData?.length > 0 && TrueTwinData?.map((truetwin, i) => {
                if (i < 3) {
                    return (
                        <CustomToolTip
                            key={i}
                            title={truetwin?.['Name']}
                            placement="top"
                        >
                            <div id="trueTwin_icon" className='truetwin-hover-ani' onClick={(e) => {
                                e.stopPropagation()
                                navigateTo(`${mission_name}/${mission_id}/${satellite['name']}/${satellite['uniqueId']}/truetwin_details/${truetwin?.['Name']}/${truetwin?.['trueTwinId']}/Configuration`, navigate)
                            }}>
                                <img src={require('../../assets/images/TrueTwin_Icon.svg').default} width='26px' height='26px' alt={`TrueTwin`} />
                            </div>
                        </CustomToolTip>
                    )
                }
            })}
            {TrueTwinData?.length > 3 && <span className='add-mission-TrueTwin'>
                <span className='d-flex align-items-center' style={{ fontSize: '12px', marginRight: '3px' }}>
                    <i className="fe fe-plus fs-12"></i>{TrueTwinData?.length - 3}
                </span>
            </span>}
        </div>
    )

}
export default MissionDetails
